import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PhoneApprovalComponent from "../../components/Approval/PhoneApprovalComponent";
import Students from "../Students/Students";
import { Phone, Users, ShieldCheck } from "lucide-react";
import { getWithTokenAPI } from "../../util/Api";

const ApprovalPage = () => {
  const { roleType, token } = useSelector((state) => state.auth);
  const isSuperAdmin = roleType === "superadmin";

  const [activeSection, setActiveSection] = useState(isSuperAdmin ? "phone" : "students");
  const [pendingPhoneCount, setPendingPhoneCount] = useState(0);

  useEffect(() => {
    if (token && isSuperAdmin) {
      getWithTokenAPI(token, "/user/phone-update/requests?status=Pending")
        .then((res) => {
          if (res?.statusCode === 200 && Array.isArray(res?.data)) {
            setPendingPhoneCount(res.data.length);
          }
        })
        .catch(() => {});
    }
  }, [token, isSuperAdmin, activeSection]);

  return (
    <div style={{ padding: "24px", maxWidth: "1400px", margin: "0 auto", fontFamily: "'Alata', sans-serif" }}>
      {/* Header */}
      <div style={{ marginBottom: "24px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "6px" }}>
          <div
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              background: "#eff6ff",
              color: "#2563eb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ShieldCheck size={22} />
          </div>
          <h2 style={{ fontSize: "26px", fontWeight: "700", color: "#1b2559", margin: 0 }}>
            Approval Center
          </h2>
        </div>
        <p style={{ margin: 0, color: "#64748b", fontSize: "14px" }}>
          Review, verify, and approve or reject profile change and verification requests across the platform.
        </p>
      </div>

      {/* Main Switcher Tabs */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "24px",
          background: "#f1f5f9",
          padding: "6px",
          borderRadius: "12px",
          width: "fit-content",
        }}
      >
        {isSuperAdmin && (
          <button
            type="button"
            onClick={() => setActiveSection("phone")}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              background: activeSection === "phone" ? "#ffffff" : "transparent",
              color: activeSection === "phone" ? "#2563eb" : "#64748b",
              fontWeight: "600",
              fontSize: "14px",
              cursor: "pointer",
              boxShadow: activeSection === "phone" ? "0 2px 6px rgba(0,0,0,0.06)" : "none",
              transition: "all 0.2s ease",
            }}
          >
            <Phone size={17} />
            <span>Institution Phone Requests</span>
            {pendingPhoneCount > 0 && (
              <span
                style={{
                  background: activeSection === "phone" ? "#2563eb" : "#ef4444",
                  color: "#ffffff",
                  fontSize: "11px",
                  fontWeight: 700,
                  borderRadius: "10px",
                  padding: "1px 7px",
                  marginLeft: "4px",
                }}
              >
                {pendingPhoneCount}
              </span>
            )}
          </button>
        )}

        <button
          type="button"
          onClick={() => setActiveSection("students")}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px 20px",
            borderRadius: "8px",
            border: "none",
            background: activeSection === "students" ? "#ffffff" : "transparent",
            color: activeSection === "students" ? "#2563eb" : "#64748b",
            fontWeight: "600",
            fontSize: "14px",
            cursor: "pointer",
            boxShadow: activeSection === "students" ? "0 2px 6px rgba(0,0,0,0.06)" : "none",
            transition: "all 0.2s ease",
          }}
        >
          <Users size={17} />
          <span>Student Approvals</span>
        </button>
      </div>

      {/* Content Section */}
      {activeSection === "phone" && isSuperAdmin ? (
        <PhoneApprovalComponent />
      ) : (
        <Students />
      )}
    </div>
  );
};

export default ApprovalPage;
